export default {
  state: {
    effectTime: ''
  },
  mutations: {
    updateTodoTask (state, currentTime) {
      state.effectTime = currentTime
    }
  }
}
